import React from 'react';
import Layout from '../components/Layout';
import AboutContent from '../components/AboutContent';

const About: React.FC = () => {
  return (
    <Layout>
      <AboutContent />
    </Layout>
  );
};

export default About;